import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { CREATE_PLC_SAFETY_ZONE_DEPENDENCY } from './actionTypes';
import { createPlcSafetyZoneDependencySuccessful, createPlcSafetyZoneDependencyFailed } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* createZoneDependency({ payload: { zoneDependency } }) {
  try {
    const response = yield call(
      plcSafetyAPI.createZoneDependency,
      zoneDependency.token,
      zoneDependency,
    );
    if (response.message) {
      yield put(createPlcSafetyZoneDependencySuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(createPlcSafetyZoneDependencyFailed(error));
  }
}

export function* watchCreatePlcSafetyZoneDependency() {
  yield takeEvery(CREATE_PLC_SAFETY_ZONE_DEPENDENCY, createZoneDependency);
}

function* createPlcSafetyZoneDependencySaga() {
  yield all([fork(watchCreatePlcSafetyZoneDependency)]);
}

export default createPlcSafetyZoneDependencySaga;
